import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import bindAll from 'lodash.bindall';

import AuthModal from './auth-modal.jsx';
import authApi from '../lib/auth-api.js';
import {clearSession} from '../reducers/session.js';

/**
 * HOC that provides auth modal and login/logout handlers to the menu bar.
 * Wraps the GUI component to inject auth-related props.
 */
const AuthManagerHOC = function (WrappedComponent) {
    class AuthManager extends React.Component {
        constructor (props) {
            super(props);
            bindAll(this, [
                'handleOpenLogin',
                'handleOpenRegistration',
                'handleCloseAuth',
                'handleLogOut'
            ]);
            this.state = {
                showAuthModal: false,
                authMode: 'login' // 'login' or 'register'
            };
        }

        handleOpenLogin () {
            this.setState({showAuthModal: true, authMode: 'login'});
        }

        handleOpenRegistration () {
            this.setState({showAuthModal: true, authMode: 'register'});
        }

        handleCloseAuth () {
            this.setState({showAuthModal: false});
        }

        async handleLogOut () {
            await authApi.logout();
            this.props.onClearSession();
        }

        render () {
            const {
                onClearSession, // eslint-disable-line no-unused-vars
                ...props
            } = this.props;
            return (
                <React.Fragment>
                    <WrappedComponent
                        {...props}
                        onLogOut={this.handleLogOut}
                        onOpenRegistration={this.handleOpenRegistration}
                        onToggleLoginOpen={this.handleOpenLogin}
                    />
                    {this.state.showAuthModal && (
                        <AuthModal
                            initialMode={this.state.authMode}
                            onClose={this.handleCloseAuth}
                        />
                    )}
                </React.Fragment>
            );
        }
    }

    AuthManager.propTypes = {
        onClearSession: PropTypes.func.isRequired
    };

    const mapDispatchToProps = dispatch => ({
        onClearSession: () => dispatch(clearSession())
    });

    return connect(null, mapDispatchToProps)(AuthManager);
};

export default AuthManagerHOC;
